import useSWR from "swr";
import {
  Alert,
  Avatar,
  CircularProgress,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import { dateTimeFromApiFmt } from "../formatters";
import { Fragment } from "react";

export default function CommentsList({ api, entity, ident }) {
  const swrKey = !!entity && !!ident ? `/comments/${entity}/${ident}` : null;

  const { isLoading, error, data } = useSWR(swrKey, () =>
    api.getComments(entity, ident),
  );

  if (swrKey === null) return null;

  if (error) {
    return <Alert severity="error">{error.message}</Alert>;
  }

  if (isLoading || !data) {
    return <CircularProgress />;
  }

  if (data.length === 0) {
    return <Typography variant="body2">No comments to show.</Typography>;
  }

  return (
    <List dense disablePadding>
      {data.map((c, i) => {
        return (
          <Fragment key={c.id}>
            {i === 0 ? null : <Divider component="li" />}
            <ListItem alignItems="flex-start" disablePadding>
              <ListItemAvatar sx={{ alignItems: "top", minWidth: "36px" }}>
                <Avatar
                  alt={c.user_name}
                  src={c.user_pic}
                  sx={{ width: 24, height: 24 }}
                />
              </ListItemAvatar>
              <ListItemText
                primaryTypographyProps={{
                  variant: "caption",
                  fontWeight: 400,
                  mb: "4px",
                }}
                secondaryTypographyProps={{
                  whiteSpace: "pre-line",
                  fontWeight: 400,
                  variant: "body2",
                }}
                primary={`${c.user_name} • ${dateTimeFromApiFmt(c.created_on)}`}
                secondary={c.comment}
              />
            </ListItem>
          </Fragment>
        );
      })}
    </List>
  );
}
